import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Image, Video, Users, MessageSquare, Calendar, TrendingUp } from 'lucide-react';

const DashboardHome = () => {
  const stats = [
    { icon: Image, label: 'Gallery Photos', value: '12', color: 'text-blue-500' },
    { icon: Video, label: 'Event Videos', value: '4', color: 'text-purple-500' },
    { icon: Users, label: 'Artists', value: '3', color: 'text-green-500' },
    { icon: MessageSquare, label: 'Reviews', value: '8', color: 'text-yellow-500' },
    { icon: Calendar, label: 'Bookings', value: 'View All', color: 'text-red-500' },
  ];

  return (
    <div>
      <h2 className="text-3xl font-black text-white mb-8 uppercase">Dashboard Overview</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        {stats.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <Card key={index} className="bg-zinc-900 border-zinc-800">
              <CardContent className="pt-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-gray-400 text-sm font-semibold uppercase">{stat.label}</p>
                    <p className="text-3xl font-black text-white mt-2">{stat.value}</p>
                  </div>
                  <Icon className={`w-12 h-12 ${stat.color}`} />
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <Card className="bg-zinc-900 border-zinc-800">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2">
            <TrendingUp className="w-5 h-5 text-red-600" />
            Quick Actions
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="bg-zinc-800 p-4 rounded-lg">
              <h3 className="text-white font-bold mb-2">Upload New Tattoo</h3>
              <p className="text-gray-400 text-sm">Add new work to your gallery</p>
            </div>
            <div className="bg-zinc-800 p-4 rounded-lg">
              <h3 className="text-white font-bold mb-2">Upload Event Video</h3>
              <p className="text-gray-400 text-sm">Share your latest events</p>
            </div>
            <div className="bg-zinc-800 p-4 rounded-lg">
              <h3 className="text-white font-bold mb-2">Manage Bookings</h3>
              <p className="text-gray-400 text-sm">View and update appointments</p>
            </div>
            <div className="bg-zinc-800 p-4 rounded-lg">
              <h3 className="text-white font-bold mb-2">Approve Reviews</h3>
              <p className="text-gray-400 text-sm">Moderate customer feedback</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default DashboardHome;
